// i18n area 'networks' — locale pl-PL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.pl-PL.meta.json.
import type { enUS } from './networks'

export const plPL: typeof enUS = {
  networks: {
    common: {
      name: 'Nazwa',
      scope: 'Scope',
      operState: 'Stan',
      actions: 'Akcje',
      create: 'Utwórz',
      close: 'Zamknij',
      cancel: 'Anuluj',
      delete: 'Usuń',
      edit: 'Edytuj',
      save: 'Zapisz',
      editError: 'Edycja nie powiodła się',
      search: 'Szukaj według nazwy',
      empty: 'Jeszcze nic tu nie ma',
      saveError: 'Nie można zapisać',
      loadError: 'Nie można wczytać — czy backend TVirt jest osiągalny?',
      createError: 'Utworzenie nie powiodło się',
      deleteError: 'Usunięcie nie powiodło się',
      deleteConfirmTitle: 'Usunąć {name}?',
      deleteConfirmBody: 'Tej operacji nie da się cofnąć.',
      nameHint: 'Małe litery, cyfry i myślniki (DNS-1123)',
      up: 'Aktywna',
      down: 'Nieaktywna',
      unknown: 'Nieznany',
      usedByVMs: 'VM',
      emptyTable: 'Brak pozycji — dodaj ją przyciskiem +'
    },
    dialogTabs: {
      general: 'Ogólne',
      base: 'Definicja podstawowa',
      advanced: 'Konfiguracja zaawansowana',
      reserved: 'Zakresy zarezerwowane dla TVirt',
      position: 'Położenie',
      network: 'Konfiguracja sieci',
      hosts: 'Uczestniczące węzły'
    },
    reservedRanges: {
      note: 'To są zakresy IP zarezerwowane dla TVirt, z których platforma może automatycznie przydzielać adresy maszynom VM, kontenerom itd. UWAGA: adresów z tych zakresów nie mogą używać poza TVirt zewnętrzne usługi ani urządzenia.',
      from: 'Od',
      to: 'Do'
    },
    overlay: {
      title: 'Sieci overlay',
      createTitle: 'Utwórz sieć overlay',
      editTitle: 'Edytuj sieć overlay',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — przydzielany automatycznie, jeśli pole zostanie puste',
      subnet: 'Podsieć',
      subnetHint: 'CIDR sieci overlay — IPAM automatycznie wyprowadza z niego wpis w rejestrze',
      mtu: 'MTU',
      weight: 'Waga',
      ceilMbps: 'Pułap (Mbps)',
      fairnessHint: 'Waga liczy się tylko przy rywalizacji: na wolnym łączu każda sieć może użyć całego pasma. Pułap obowiązuje natomiast zawsze.',
      contention: 'Rywalizacja',
      contentionTip: 'Co najmniej jeden węzeł obserwuje odrzucenia lub overlimity Z kolejką na klasie tej sieci: pasmo uplinku jest sporne i wagi działają. Ile i od kiedy — w seriach net.shaping.* węzła.',
      firewallPolicy: 'Polityka firewalla',
      hosts: 'Hosty',
      hostsTitle: 'Uczestniczące węzły',
      hostsHint: 'Każdy węzeł deklaruje swój endpoint underlay — lista wyboru z RZECZYWISTYCH adresów węzła, odczytanych z jego konfiguracji sieci; opcjonalny adres w sieci overlay musi mieścić się w podsieci. Uczestnictwo jest ograniczeniem placementu.',
      hostNode: 'Węzeł',
      hostUnderlay: 'IP underlay',
      hostUnderlayPickNode: 'Najpierw wybierz węzeł',
      hostAddress: 'Adres w sieci overlay (opcjonalnie)',
      hostAddressOutside: 'Poza podsiecią overlaya ({cidr})',
      addHost: 'Dodaj węzeł',

      // Runda #156 (standardowy dialog): obserwowane wiersze dialogu szczegółów.
      observedAt: 'Zaobserwowano',
      attachedNics: 'Podłączone NIC'
    },
    services: {
      title: 'Usługi sieciowe',
      createTitle: 'Utwórz usługę sieciową',
      editTitle: 'Edytuj usługę sieciową',
      kind: 'Typ',
      kindCategory: 'Usługi',
      selectKindHint: 'Wybierz typ usługi — demon działający pod spodem to szczegół implementacyjny, którym zajmuje się TVirt.',
      kindLabel: {
        dhcp: 'Serwer DHCP',
        ntp: 'Serwer NTP',
        vpn: 'Serwer VPN',
        dns: 'Serwer DNS',
        gateway: 'Brama',
        'lb-rp': 'Load balancer i reverse proxy',
        floatip: 'Pływające IP'
      },
      kindDesc: {
        dhcp: 'Przydziela adresy w obsługiwanych podsieciach — pule wynikają z podsieci, bramy i zakresów zarezerwowanych dla TVirt w danej sieci.',
        dns: 'Autorytatywny DNS dla zadeklarowanych stref — rekordy pochodzą z IPAM oraz z wpisów dodanych ręcznie.',
        gateway: 'Węzeł pełni rolę bramy dla sieci — NAT (DNAT, 1:1, SNAT/masquerade) oraz routing statyczny między podłączonymi sieciami, z założenia samonaprawialny.',
        'lb-rp': 'Load balancer / reverse proxy przed Twoimi usługami — listenery L4 lub L7 nad pulami członków lub nad gotowymi instancjami Poda, rekonfigurowane w locie.',
        ntp: 'Usługa czasu dla sieci — przekazywanie czasu z zewnętrznych serwerów upstream albo zegar węzła serwowany klientom.',
        vpn: 'Koncentrator VPN na węźle — WireGuard albo OpenVPN, do wyboru: zdalny dostęp dla klientów mobilnych albo tunel site to site między dwiema sieciami.',
        floatip: 'Jeden adres, który siedzi na jednej zdrowej instancji App lub Podzie naraz i przenosi się na następny zdrowy cel, gdy tamten padnie — failover bez demonów; równoważenie zostaje przy load balancerze.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Pływające IP żyje w wybranej sieci jako DODATKOWY adres wewnątrz przestrzeni nazw instancji posiadacza: bez portów, bez równoważenia, bez NAT — IP klienta pozostaje prawdziwe.',
        address: 'Pływające IP',
        targets: 'Cele',
        targetsHint: 'W kolejności PREFERENCJI: pierwszy zdrowy cel trzyma adres. Pod oznacza wszystkie jego instancje, po replikach; każdy cel ma własne kryterium zdrowia. Każdy cel musi być podłączony do tej samej sieci.',
        targetKind: 'Cel',
        targetApp: 'Instancja App',
        targetPod: 'Pod (wszystkie instancje)',
        targetRef: 'Który',
        health: 'Zdrowie',
        healthRunning: 'Działa (każdy kontener gotowy)',
        healthTcp: 'Połączenie TCP',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Port',
        path: 'Ścieżka',
        addTarget: 'Dodaj cel',
        moveUp: 'Przesuń w górę',
        moveDown: 'Przesuń w dół',
        preempt: 'Preempt',
        preemptHint: 'Wyłączone (domyślnie): zdrowy posiadacz zachowuje adres nawet gdy wyższy cel wraca — bez przeskakiwania. Włączone: pierwszy zdrowy cel zawsze go trzyma.',
        holder: 'Posiadacz',
        noHolder: 'brak zdrowego celu',
        since: 'od',
        verdicts: 'Obserwowane cele',
        healthy: 'zdrowy',
        unhealthy: 'niezdrowy',
        noVerdict: 'Jeszcze nie zdecydowano — węzeł autorytatywny zapisze pierwszy werdykt przy następnym przebiegu.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'Ta instancja trzyma pływające IP {address} usługi {service}'
      },
      poolSource: 'Punkty końcowe',
      poolSourceMembers: 'Statyczni członkowie',
      poolSourcePod: 'Gotowe instancje Poda',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Port',
      poolBackendHint: 'Punkty końcowe podążają za Podem: instancja dołącza, gdy działa z każdym kontenerem gotowym, i natychmiast odchodzi, gdy zostaje zmniejszona lub umiera. Aktywna kontrola jest domyślnie włączona.',
      poolBackendCount: 'gotowe instancje Poda {pod} na porcie {port}',
      node: 'Węzeł',
      enabled: 'Włączona',
      parked: 'Zaparkowana',
      subnets: 'Podsieci',
      subnetsHint: 'Podsieci IPAM obsługiwane przez tę instancję — pule wynikają z CIDR, bramy i zakresów zarezerwowanych dla TVirt',
      noSubnets: 'Brak podsieci IPAM — zadeklaruj najpierw logiczną sieć fabric (albo podsieć overlay): IPAM wyprowadza się właśnie z nich',
      iface: 'Interfejs nasłuchu',
      ifaceHint: 'Interfejs hosta, na którym usługa otwiera swoje gniazdo (np. mostek) — wymagany: usługa sieciowa jest samowystarczalna, „wszystkie interfejsy" już nie istnieje',
      dns: 'Serwery DNS',
      domain: 'Domena',
      detail: 'Obsługuje',
      subnetCount: '{n} podsieci',
      zones: 'Strefy',
      zonesHint: 'Tylko autorytatywnie — demon nigdy nie odpytuje rekurencyjnie. Rekordy A wynikają z zadeklarowanych adresów węzłów w przywołanych podsieciach IPAM; opcja Reverse obsługuje dodatkowo odpowiadające strefy in-addr.arpa (PTR). Daną strefę obsługuje najwyżej jedna instancja DNS we flocie. Opcjonalny serwer nazw to FQDN wpisywany w rekordy NS/SOA zamiast domyślnego ns.<strefa>; jeśli mieści się w strefie, jego rekord A i tak wynika z węzła obsługującego.',
      zoneName: 'Nazwa strefy',
      zoneNs: 'Serwer nazw (NS)',
      zoneSubnets: 'Podsieci IPAM',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Rekordy ręczne',
      zoneRecordsHint: 'Jeden na wiersz: nazwa TYP wartość — typy A, CNAME, MX, TXT. Przy kolizji nazwy rekord ręczny wygrywa z wyprowadzonym.',
      addZone: 'Dodaj strefę',

      // lb-rp (fala 3, fundamenty): listenery na pulach inline — bez osobnego
      // silnika, rekonfigurowane w locie.
      lbListeningHint: 'Instancja deklaruje JEDNĄ sieć nasłuchu i JEDEN adres — każdy listener wiąże go na własnym porcie; drugi adres to druga usługa.',
      listeners: 'Listenery',
      listenersHint: 'Każdy listener wiąże adres instancji na własnym porcie w trybie L4 (passthrough TCP — bajty nigdy nie są otwierane) lub L7 (HTTP) i przekazuje do jednej z pul poniżej. Parę adres/port obsługuje co najwyżej jedna instancja na węzeł. Zmiany wchodzą w locie — bez restartu, bez utraconych połączeń.',
      listenerName: 'Nazwa',
      listenerMode: 'Tryb',
      modeL7: 'L7 — reverse proxy HTTP',
      modeL4: 'L4 — passthrough TCP',
      listenerPort: 'Port',
      listenerPool: 'Pula',
      addListener: 'Dodaj listener',
      pools: 'Pule',
      poolsHint: 'Backendy, na których ląduje ruch: statyczni członkowie równoważeni metodą round robin albo „najmniej obciążony”, z opcjonalnym aktywnym health checkiem, który wyłącza z rotacji członków w złej kondycji.',
      poolName: 'Nazwa',
      poolAlgorithm: 'Algorytm',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Najmniej obciążony',
      poolCheck: 'Health check',
      checkNone: 'Brak',
      checkTcp: 'Połączenie TCP',
      checkHttp: 'HTTP',
      poolCheckPath: 'Ścieżka sondy',
      poolInterval: 'Interwał (s)',
      poolMembers: 'Członkowie',
      poolMembersHint: 'Jeden na wiersz: adres:port, opcjonalnie z wagą (1-128) — np. 10.0.0.21:8080 2',
      addPool: 'Dodaj pulę',
      memberCount: '{n} członków',

      // ntp (runda ntp — ratyfikacja 2026-08-03, ostatni kind rodziny): tryb
      // opisany zwykłymi słowami, lista upstream tylko tam, gdzie coś znaczy,
      // podłączenie do sieci używa etykiet bramy.
      listen: {
        assignment: 'Przydział',
        assignmentStatic: 'Adres statyczny',
        assignmentAuto: 'Automatyczny (zakresy zarezerwowane TVirt)',
        autoHint: 'TVirt wyciąga adres z zarezerwowanych zakresów sieci logicznej i trzyma go sticky — nigdy nie losowany ponownie przy edycji ani failoverze.',
        title: 'Listenery',
        hint: 'Usługa sieciowa jest samowystarczalna: każdy listener deklaruje swoją sieć (overlay, logiczną sieć fabric lub surowy interfejs) i adres w jej podsieci — jeden listener na adres, wildcard już nie istnieje. DNS i NTP mogą nasłuchiwać w wielu sieciach i na wielu adresach tych sieci.',
        address: 'Adres nasłuchu',
        add: 'Dodaj listener'
      },
      ntp: {
        mode: 'Tryb synchronizacji',
        modeRelay: 'Przekazywanie z serwerów zewnętrznych',
        modeNodeClock: 'Zegar węzła',
        modeHint: 'Przekazywanie serwuje czas pobrany z zadeklarowanych serwerów upstream; zegar węzła serwuje czas węzła obsługującego — który klaster i tak utrzymuje zsynchronizowany',
        servers: 'Serwery upstream',
        serversHint: 'Rozdzielone przecinkami — nazwa hosta albo adres IP; usługa pobiera stąd czas i serwuje go w sieci',
        port: 'Port nasłuchu',
        listening: 'Nasłuchuje na'
      },

      vpn: {
        engine: 'Silnik',
        engineHint: 'Wybiera się go raz, na stałe: WireGuard jest nowoczesny, szybki i działa w jądrze; OpenVPN to weteran kompatybilności (TCP, nieprzyjazne sieci)',
        engineLocked: 'Silnik jest niezmienny — inny silnik to nowa usługa, klucze i certyfikaty nie są przenośne',
        mode: 'Tryb',
        modeRemote: 'Zdalny dostęp',
        modeSite: 'Site to site',
        modeHint: 'Zdalny dostęp daje klientom mobilnym adres w tunelu; site to site łączy dwie sieci',
        port: 'Port nasłuchu',
        protocol: 'Transport',
        protocolWireguardHint: 'WireGuard mówi wyłącznie po UDP',
        tunnelSubnet: 'Podsieć tunelu',
        tunnelSubnetHint: 'Sieć, w której żyją klienci — zapisana w rejestrze IPAM, powstaje i znika razem z tą usługą',
        dnsServers: 'DNS wypychane do klientów',
        routes: 'Trasy wypychane do klientów',
        routesHint: 'Sieci rozdzielone przecinkami, osiągalne przez tunel; podsieć tunelu jest zawsze uwzględniona',
        peers: 'Peery',
        peersHint: 'Puste pole klucza publicznego oznacza, że TVirt wygeneruje parę kluczy — i dostarczy ją razem z profilem. Wklejony klucz oznacza, że peer zachowuje własny.',
        clients: 'Klienci',
        clientsHint: 'Każdy klient dostaje certyfikat wystawiony przez CA tej usługi. Usunięcie klienta go UNIEWAŻNIA: lista CRL jest natychmiast generowana od nowa.',
        peerName: 'Nazwa',
        publicKey: 'Klucz publiczny',
        publicKeyMinted: 'Wygeneruje go TVirt',
        peerAddress: 'Adres w tunelu',
        peerAddressHint: 'Puste = przydzielony',
        allowedIps: 'Podsieci zdalne',
        allowedIpsHint: 'Rozdzielone przecinkami, trasowane przez tego peera',
        endpoint: 'Endpoint',
        presharedKey: 'Klucz współdzielony',
        keepalive: 'Keepalive (s)',
        addPeer: 'Dodaj peera',
        addClient: 'Dodaj klienta',
        auth: 'Uwierzytelnianie',
        authTls: 'Certyfikaty (TLS)',
        remote: 'Zdalny endpoint',
        remoteHint: 'host:port drugiego końca — puste oznacza, że ta strona czeka',
        peerRoutes: 'Podsieci zdalne',
        serverPublicKey: 'Klucz publiczny tego serwera',
        ca: 'Urząd certyfikacji',
        listening: 'Nasłuchuje na',
        tunnel: 'Tunel',
        peerCount: '{n} peerów',
        download: 'Pobierz profil',
        downloadError: 'Nie udało się wyeksportować profilu',
        lastHandshake: 'Ostatni handshake',
        never: 'nigdy',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Połączony',
        idle: 'Bezczynny'
      },

      // Brama (fala 3 — narodziny nat, ratyfikacja 2026-08-01/02; przemianowana
      // i rozszerzona 2026-08-03): trzy rodziny reguł NAT plus trasy statyczne
      // w sieci nasłuchu. Każda ratyfikowana forma jest obsługiwana.
      gateway: {
        attach: 'Typ sieci nasłuchu',
        attachOverlay: 'Sieć overlay',
        attachNetwork: 'Logiczna sieć fabric',
        attachInterface: 'Surowy interfejs',
        overlay: 'Sieć overlay',
        network: 'Sieć logiczna',
        interface: 'Nazwa interfejsu',
        interfaceHint: 'Interfejs hosta, którym TVirt nie zarządza — jego adres przyjmuje się na wiarę',
        address: 'Adres nasłuchu (brama)',
        addressHint: 'Adres bramy, na który wskazują klienci — w obrębie podsieci sieci nasłuchu',
        dnatTitle: 'Reguły DNAT',
        dnatHint: 'NAT docelowy: ruch pasujący do reguły jest przekierowywany na nowy adres (i opcjonalnie na nowy port). Dowolny protokół z listy — porty tam, gdzie protokół je przewiduje.',
        snatTitle: 'Reguły SNAT',
        snatHint: 'NAT źródłowy: ruch pasujący do reguły wychodzi z przepisanym źródłem — nowym, jawnym adresem (i opcjonalnie nowym portem) albo z maskaradą na adresie wyjściowym, jeśli pole pozostanie puste.',
        oneToOneTitle: 'Reguły NAT 1:1',
        oneToOneHint: 'Każdy pakiet kierowany na adres zewnętrzny mapuje się na wewnętrzny, a host wewnętrzny wychodzi jako zewnętrzny — wszystkie protokoły, w obie strony.',
        external: 'Adres zewnętrzny',
        internal: 'Adres wewnętrzny',
        addOneToOne: 'Dodaj regułę 1:1',
        family: 'Rodzina',
        protocol: 'Protokół',
        source: 'Źródło (adres/podsieć)',
        destination: 'Cel (adres/podsieć)',
        invert: 'NOT',
        srcPorts: 'Porty źródłowe',
        dstPorts: 'Porty docelowe',
        dstPortsHint: 'Port albo zakres (80, 8000-8099)',
        toAddress: 'Nowy adres',
        toPort: 'Nowy port',
        snatTo: 'Nowe źródło (puste = maskarada)',
        snatToHint: 'Jawny adres źródłowy; puste = maskarada na adresie wyjściowym',
        addDnat: 'Dodaj regułę DNAT',
        addSnat: 'Dodaj regułę SNAT',
        routesTitle: 'Trasy statyczne',
        routesHint: 'Węzeł trasuje ruch między sieciami, do których jest podłączony (przekazywanie IP jest włączone); te trasy dokładają osiągalność ponad tamte — czyste jądro, routing dynamiczny pojawi się w kolejnej rundzie.',
        routeDestination: 'Podsieć docelowa',
        routeGateway: 'Next hop',
        routeMetric: 'Metryka',
        addRoute: 'Dodaj trasę',
        listening: 'Nasłuchuje na',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} tras'
      },
      unknownSince: 'Nieznany — ostatni raport {m} min temu',
      lastWord: 'Ostatnie słowo',

      // Runda #156 (standardowy dialog): obserwowane wiersze i podsumowanie
      // bloku kind w trybie tylko do odczytu w dialogu szczegółów.
      reportObservedAt: 'Ostatni raport',
      lastErrorRow: 'Ostatni błąd',
      recordsCount: '{n} rekordów ręcznych',
      phase: {
        configured: 'Skonfigurowana',
        running: 'Działa',
        error: 'Błąd'
      },
      authorityNode: 'Authority (przypisanie)',
      preferredNode: 'Preferowany węzeł',
      preferredNodeHint: 'Miękka preferencja, nigdy ograniczenie: przy następnej decyzji placementu instancja ląduje tutaj, jeśli ten członek się kwalifikuje — sama z siebie niczego nie przenosi; ruchem jest „Przenieś authority”.',
      noPreference: 'Brak preferencji (automatyczny placement)',
      moving: 'W ruchu',
      movingTooltip: 'Obserwowana tutaj, podczas gdy authority przypisuje {node}: ruch właśnie zbiega do celu.',
      placement: {
        title: 'Placement',
        loading: 'Spis w toku…',
        loadError: 'Spis placementu nie odpowiedział — spróbuj później.',
        draftHint: 'Spis liczy się z zadeklarowanego podłączenia sieci: pojawi się, gdy usługa powstanie. Utworzenie jest odrzucane, gdy żaden członek nie może jej obsługiwać, a odmowa wymienia mechanizm, który opróżnił zbiór.',
        eligibleCount: '{n} z {m} członków może obsługiwać tę instancję',
        recommended: 'Zalecany',
        eligible: 'Kwalifikuje się',
        notEligible: 'Nie kwalifikuje się',
        blockedReachability: 'sieć nie dociera do tego członka',
        blockedRequireTag: 'zablokowany przez wymagany tag (requireNodes)',
        blockedExcluded: 'wykluczony przez symulację',
        preferenceUnknown: 'nie jest (już) członkiem klastra',
        preferenceIgnored: 'Preferencja „{node}” dziś się nie kwalifikuje: {reason}. Górą jest zalecenie spisu — nigdy błąd, usługa żyje gdzie indziej.',
        emptyReachability: 'Żaden członek nie może obsługiwać tej instancji: sieć nie dociera nigdzie — żadna poprawka tagów nie pomoże. Okabluj węzeł albo przenieś usługę tam, gdzie sieć jest.',
        emptyRequireTag: 'Żaden członek nie może obsługiwać tej instancji: to wymagane tagi opróżniły zbiór — usuń wpis z requireNodes albo otaguj któregoś członka.',
        spof: 'Pojedynczy punkt awarii',
        spofDetail: 'Instancję może gościć tylko jeden członek: przy awarii failover nie ma dokąd pójść. Usługa z wieloma listenerami przenosi się jako CAŁOŚĆ — kandydat musi widzieć WSZYSTKIE jej sieci: taka jest cena.',
        whatIf: 'Symuluj nieobecnych członków',
        whatIfHint: 'What-if opróżniania: zapytaj PRZED ewakuacją, zamiast odkrywać to przy failoverze.',
        survives: 'Bez {nodes} usługa wciąż ma dom.',
        notSurvives: 'Ewakuacja {nodes} zostawia tę usługę WYŁĄCZONĄ: ograniczenie pochodne wygrywa z dostępnością (R30) — demon żywy tam, gdzie sieć nie dociera, nikomu nie służy i nikogo nie alarmuje.',
        transfer: 'Przenieś authority',
        transferError: 'Przeniesienie nie powiodło się',
        transferTarget: 'Członek docelowy',
        transferHint: 'Proponowani są tylko członkowie, którzy się kwalifikują — preferencja wewnątrz poprawnego zbioru, nigdy override. Bez taska: następny przebieg workerów JEST ruchem (stary węzeł zbiera, nowy realizuje).'
      }
    },
    fabric: {
      tabDerivation: 'Derywacja',
      importNetwork: 'Importuj z innego fabricu',
      importTitle: 'Importuj sieć logiczną',
      importHint: 'Import to jawne przystąpienie: sieć pozostaje właściciela (ta sama tożsamość, ten sam stem, ten sam bridge tvf-<stem>) i stąd mapuje się ją na porty/LAGG tego fabricu — mapować ZNACZY twierdzić, że dostarczenie trafia do tej samej domeny L2 co u właściciela.',
      importPick: 'Sieć właściciela',
      importNone: 'Nie ma czego importować: pozostałe fabrici nie mają własnej sieci, której ten fabric już by nie znał',
      importedNetworksTitle: 'Sieci importowane',
      noImported: 'Brak importowanej sieci',
      importedFrom: 'importowana z {fabric}',
      importedBy: 'Importują: {list}',
      importedCount: '+{n} importowanych',
      owner: 'Właściciel',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Usuń import',
      unimportConfirm: 'Usunąć import sieci {name} (właściciel {fabric}) z tego fabricu? Odrzucane, dopóki port lub LAGG tego fabricu ją mapuje, albo gość, App lub usługa są obsługiwane wyłącznie przez tę nogę.',
      unimportRefused: 'Import wciąż w użyciu — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'Ten węzeł już pobiera tę sieć z innego fabricu, którego jest członkiem: węzeł bierze sieć współdzieloną tylko JEDNĄ ze swoich nóg (dwa uplinki tego samego L2 w bridge’u bez STP to pętla). Odmapuj ją na portach lub LAGG jednego z dwóch fabriców.',
          otherFabricDerived: 'Dokument niesie blok fabricu, ku któremu węzeł nie deklaruje już kabla: najpierw zastosuj plan tego fabricu (proponuje usunięcie jego urządzeń) albo przejmij je przez take-ownership, jeśli fabricu już nie ma.'
        },
        hint: 'Plan derywacji O.3: dla każdego okablowanego węzła stan, diff wyprowadzone-vs-bieżące, ZADEKLAROWANA topologia bondów, flipy dual-stack i ustrukturyzowane odmowy/ostrzeżenia. Tylko do odczytu aż do JAWNEGO apply — nic nigdy nie ląduje na węźle samo.',
        refresh: 'Przeładuj plan',
        empty: 'Żaden węzeł nie jest okablowany do tej fabric (i żaden nie nosi już jej bloku).',
        refusal: 'Odmowa',
        warning: 'Ostrzeżenie',
        generation: 'generacja dokumentu {n}',
        state: {
          manual: 'Ręczny',
          derived: 'Wyprowadzony',
          diverged: 'Rozbieżny'
        },
        topologyTitle: 'Zadeklarowana topologia',
        members: 'członkowie',
        primary: 'podstawowy',
        held: 'utrzymany na JEDNYM członku',
        form: {
          perNetworkBond: 'Bond na sieć',
          singleBond: 'Pojedynczy bond zapasowy',
          laggBond: 'Bond LACP (LAGG)',
          singlePort: 'Pojedynczy port'
        },
        colAction: 'Akcja',
        colKind: 'Rodzaj',
        colDevice: 'Device',
        colDetail: 'Szczegół',
        action: {
          add: 'dodaj',
          remove: 'usuń',
          replace: 'zastąp'
        },
        diffEmpty: 'Brak oczekującego diffa — zastosowany dokument zgadza się z renderem.',
        diffBlocked: 'Brak diffa: powyższe odmowy blokują ten węzeł.',
        phasePlanned: 'zaplanowany (krok 1 z 3)',
        phaseDraining: 'opróżnianie (krok 2 z 3)',
        probeUnobserved: 'Sonda opróżniania: nigdy nie zgłoszona — pustka jest NIEZNANA (retire zostałby teraz odmówiony).',
        probeFailed: 'Sonda opróżniania: obserwacja NIEUDANA — znane znaczniki czasu są przenoszone, nigdy «puste», którego nikt nie zmierzył.',
        probeActive: {
          one: 'Sonda: {n} nawiązane połączenie wciąż na starym adresie',
          few: 'Sonda: {n} nawiązane połączenia wciąż na starym adresie',
          many: 'Sonda: {n} nawiązanych połączeń wciąż na starym adresie',
          other: 'Sonda: {n} nawiązanego połączenia wciąż na starym adresie'
        },
        probeLastActive: 'ostatnia aktywność {time}',
        probeEmpty: {
          one: 'Sonda: pusty od {n} minuty',
          few: 'Sonda: pusty od {n} minut',
          many: 'Sonda: pusty od {n} minut',
          other: 'Sonda: pusty od {n} minuty'
        },
        probeEmptyUnknown: 'Sonda: pusty (od kiedy — nieznane).',
        impact: '{nics} vNIC i {apps} App na tym węźle używają tych sieci: {list}',
        apply: 'Zastosuj na tym węźle',
        applyTitle: 'Zastosuj derywację — {node}',
        applyIntro: 'Wyprowadzona konfiguracja przepisuje dokument sieciowy węzła {node} ({n} zmian) przez te same drzwi co edytor host-network — checkpoint NetworkManagera i uczciwa sonda włącznie. Ostrzeżenia planu poniżej podróżują z aktem: przeczytaj je przed potwierdzeniem.',
        applyError: 'Apply nieudany',
        applyRefused: 'Węzeł odmówił:',
        planMoved: 'Fabric zmieniła się po tym podglądzie — NIC nie zostało zastosowane. Plan został przeładowany: spójrz ponownie i spróbuj jeszcze raz.',
        retire: 'Wycofaj',
        retireTitle: 'Punkt bez powrotu — wycofanie {address}',
        restore: 'Przywróć',
        restoreTip: 'Powrót do migawki sprzed apply (generacja {previous}) — cofnięcie o jeden krok (H13)',
        restoreTitle: 'Przywróć poprzedni dokument — {node}',
        restoreIntro: 'Dokument sieciowy węzła {node} wraca do migawki zrobionej przed ostatnim apply (generacja {previous}), zapisanej ponownie jako generacja {next} w miejsce {current}. Worker uzgadnia go jak każdy inny dokument.',
        restoreRedo: 'Zastąpiony dokument staje się nową migawką: ponowne przywrócenie to redo.',
        restoreClosesChain: 'Migawka to ręczny dokument sprzed derywacji: łańcuch zamyka się tutaj — bez dalszego cofania, węzeł pozostaje ręczny do następnego apply.',
        restoreConfirm: 'Przywróć',
        restoreError: 'Przywracanie nie powiodło się',
        retireIntro: 'To usuwa {address} ({network}) z {point} definitywnie. Po tym akcie drogą powrotu jest ODWROTNY flip — ponowna deklaracja starego adresu przez ten sam silnik — nigdy ślepe przywracanie.',
        retireOld: 'Stary adres (usunięty)',
        retireNew: 'Nowy adres (zostaje)',
        retireEmptyFact: 'Sonda opróżniania zgłasza adres pusty: to usunięcie nie zrywa żadnego zaobserwowanego połączenia.',
        retireConfirm: 'Wycofaj adres',
        severActiveLoss: {
          one: 'Zerwij {n} nawiązane połączenie wciąż na starym adresie — umiera z tym aktem',
          few: 'Zerwij {n} nawiązane połączenia wciąż na starym adresie — umierają z tym aktem',
          many: 'Zerwij {n} nawiązanych połączeń wciąż na starym adresie — umierają z tym aktem',
          other: 'Zerwij {n} nawiązanego połączenia wciąż na starym adresie — umiera z tym aktem'
        },
        severUnknownLoss: 'Zaakceptuj NIEZNANE: sonda nigdy nie zaobserwowała tego adresu (lub obserwacja zawodzi) — żywe połączenia mogą zostać zerwane.'
      },
      title: 'Fabric',
      createTitle: 'Utwórz fabric',
      networks: 'Sieci',
      switches: 'Switche',
      ports: 'Porty',
      laggs: 'LAGG',
      subnets: 'Podsieci',
      tabOverview: 'Przegląd',
      tabNetworks: 'Sieci logiczne',
      tabSwitches: 'Switche',
      overviewHint: 'Fabric na pierwszy rzut oka: każda sieć logiczna z MTU i podsiecią (VLAN-y żyją wyłącznie w mapowaniach per port i per LAGG — ta sama sieć może jeździć z różnymi tagami na różnych portach). Fabric jest rejestrem infrastruktury ZEWNĘTRZNEJ — TVirt obserwuje i deklaruje, nigdy nie prowadzi provisioningu i dotyka wyłącznie kart NIC zarejestrowanych pod jego kontrolą.',
      absorptionHint: 'Każda zadeklarowana tutaj podsieć WYPROWADZA swój wpis w rejestrze IPAM w tym samym zapisie — żyje i umiera razem z siecią.',
      scopeFixedHint: 'Scope jest stały — korzeń klastra: infrastruktura fizyczna z definicji obejmuje cały klaster.',
      networksHint: 'Każda sieć niesie obowiązkowe MTU (domyślnie 1500) i obowiązkową podsieć; brama, serwery DNS i trasy statyczne zadeklarowane tutaj są JEDYNYM ŹRÓDŁEM dla kart NIC serwerów, aplikacji i usług sieciowych.',
      switchesHint: 'Rejestr prowadzony ręcznie: port jest nieużywany, zmapowany (ruch untagged oraz per tag VLAN na sieciach logicznych) albo jest członkiem LAGG — członek nie niesie własnych mapowań.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Obowiązkowy — IPAM automatycznie wyprowadza z niego wpis w rejestrze',
      nodeAddressing: 'Adresacja węzłów',
      nodeAddressingNone: 'Brak — bez adresu dla węzła',
      nodeAddressingPool: 'Pool — jeden stały adres na każdy obsłużony węzeł',
      nodeAddressingHint: 'Z Pool derywacja fabrica przydziela każdemu obsłużonemu węzłowi adres z zakresów zarezerwowanych dla TVirt (stały po przydzieleniu).',
      backing: 'Backing',
      gateway: 'Brama',
      ranges: 'Zakresy zarezerwowane',
      dns: 'Serwery DNS (rozdzielone przecinkami)',
      dnsShort: 'DNS',
      singleSourceHint: 'Brama, DNS i trasy zadeklarowane tutaj są jedynym źródłem — karty NIC serwerów, aplikacje i usługi sieciowe czerpią właśnie stąd',
      routesTitle: 'Trasy statyczne',
      routeDestination: 'Cel (CIDR)',
      routeVia: 'Przez (next hop)',
      portUsed: 'Używany',
      vlanMappings: 'Mapowania VLAN',
      vlanTag: 'Tag VLAN',
      vlanNetwork: 'Sieć logiczna',
      nameTaken: 'Nazwa jest już zajęta w tym fabricu',
      addNetwork: 'Dodaj sieć',
      editNetwork: 'Edytuj sieć',
      deleteNetwork: 'Usuń sieć',
      deleteNetworkConfirm: 'Usunąć sieć logiczną {name} z fabricu? Jej podsieć wyprowadzona w IPAM ginie razem z nią (operacja jest odrzucana, dopóki korzysta z niej usługa albo aplikacja). Mapowania portów i LAGG wskazujące na nią zostaną wyczyszczone.',
      switchName: 'Switch',
      portName: 'Port',
      positionHint: 'Fizyczne położenie (opcjonalnie) — to samo słownictwo co przy rozmieszczeniu serwerów; wyłącznie deklaratywne',
      addSwitch: 'Dodaj switch',
      editSwitch: 'Edytuj switch',
      deleteSwitch: 'Usuń switch',
      deleteSwitchConfirm: 'Usunąć switch {name} wraz ze wszystkimi jego portami? LAGG-i odpowiednio się skurczą (i znikną poniżej dwóch portów).',
      addPort: 'Dodaj port',
      editPort: 'Edytuj port',
      deletePort: 'Usuń port',
      deletePortConfirm: 'Usunąć port {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (tag:sieć)',
      taggedShort: 'Tagged',
      portCabling: 'Okablowanie',
      portState: 'Stan',
      stateUnused: 'nieużywany',
      stateMapped: 'zmapowany',
      laggPortGuard: 'Port będący członkiem LAGG zmienia się po stronie LAGG',
      laggsTitle: 'LAGG',
      laggsHint: 'LAGG to 2 lub więcej portów w LACP i może przechodzić między switchami (MLAG, przezroczyście); wchodzą tylko porty nieużywane, LAGG jest powierzchnią mapowania, a usunięty port wraca do stanu nieużywanego.',
      addLagg: 'Dodaj LAGG',
      editLagg: 'Edytuj LAGG',
      deleteLagg: 'Usuń LAGG',
      deleteLaggConfirm: 'Usunąć LAGG {name}? Jego porty członkowskie wracają do stanu nieużywanych.',
      lacpRate: 'Rate LACP',
      laggPorts: 'Porty członkowskie (2+)',
      laggPortsHint: 'Wchodzą tylko porty nieużywane — zwolnij najpierw port zmapowany',
      noNetworks: 'Nie zadeklarowano żadnej sieci logicznej.',
      noSwitches: 'Nie zadeklarowano żadnego switcha.',
      noLaggs: 'Nie zadeklarowano żadnego LAGG.',
      staleConflict: 'Inny operator zmienił ten fabric, gdy go edytowałeś: zapis został odrzucony, aby nie skasować jego pracy. Twoje zmiany nadal tu są, nienaruszone. Zaktualizowany fabric został już przeładowany: potwierdź ponownie, aby nałożyć je na niego, albo anuluj i zobacz, co się zmieniło.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Wyłącznie wyprowadzone: każda podsieć rodzi się z logicznej sieci fabric albo z sieci overlay — zmienia się ją u źródła. Przydzielone adresy pokazują, KTO je trzyma; zakresy zarezerwowane dla TVirt są pulami automatycznego przydziału.',
      search: 'Szukaj po nazwie, CIDR lub adresie',
      empty: 'Brak sieci — zadeklaruj logiczną sieć fabric albo podsieć overlay: IPAM wyprowadzi się z nich automatycznie.',
      reserved: 'Zakresy zarezerwowane dla TVirt',
      address: 'Adres',
      origin: 'Pochodzenie',
      origin_declared: 'zadeklarowany',
      origin_observed: 'zaobserwowany',
      holder: 'Trzymany przez',
      noAddresses: 'Brak znanych adresów w tej podsieci.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Edytuj u źródła'
    },
    firewall: {
      title: 'Grupy firewalla',
      createTitle: 'Nowa grupa firewalla',
      editTitle: 'Edytuj grupę firewalla',
      empty: 'Brak grup firewalla — utwórz jedną: słownik reguł wielokrotnego użytku, przywoływany po nazwie przez karty NIC gości.',
      nameHint: 'Litery, cyfry i wewnętrzne . - _; nazwa unikatowa w swoim scope (imienników gdzie indziej rozróżnia zapis /scope/nazwa)',
      description: 'Opis',
      descriptionHint: 'Jedna linia intencji, pokazywana wszędzie tam, gdzie wybiera się grupę',
      enforced: 'Wymuszona na scope',
      enforcedHint: 'Wyłączone: czysty słownik — reguły wiążą tylko te NIC, które przywołują grupę. Włączone: reguły wiążą każdą kartę NIC gościa z włączonym firewallem pod scope grupy, z przywołaniem czy bez.',
      enforcedChip: 'Wymuszona',
      enforcedChipHint: 'Reguły wiążą każdą kartę NIC gościa z włączonym firewallem pod scope grupy, z przywołaniem czy bez',
      enforceWarning: 'Włączenie wymuszania zwiąże reguły z KAŻDĄ kartą NIC gościa z włączonym firewallem pod {scope} od najbliższego uzgodnienia, także bez jawnego przywołania — a wewnątrz włączonej chain drop przodka jest ostateczny: poziomy niżej już go nie otworzą.',
      unenforceInfo: 'Po zdjęciu wymuszania reguły zostają tylko na tych NIC, które przywołują grupę jawnie.',
      rules: 'Reguły',
      tabOverview: 'Przegląd',
      tabRules: 'Reguły',
      orderHint: 'Kolejność wierszy JEST kolejnością ewaluacji wewnątrz grupy: wygrywa pierwsza pasująca reguła.',
      statefulHint: 'Stateful jest domyślny: odpowiedzi na dopuszczony ruch przechodzą same (established/related akceptowane, invalid odrzucany — wstrzykuje je silnik, nie pisze się ich ręcznie).',
      noRules: 'Brak reguł — słownik w budowie: przywołanie go jest dozwolone i niczego nie renderuje.',
      addRule: 'Dodaj regułę',
      direction: 'Kierunek',
      directionIn: 'Przychodzący',
      directionOut: 'Wychodzący',
      action: 'Akcja',
      action_accept: 'Akceptuj',
      action_drop: 'Porzuć',
      action_reject: 'Odrzuć',
      protocol: 'Protokół',
      protocolAny: 'Dowolny',
      ports: 'Porty',
      source: 'Źródło',
      dest: 'Cel',
      comment: 'Komentarz',
      addressHint: 'CIDR IPv4 albo <fabric>/<sieć logiczna>; puste = dowolny',
      moveUp: 'Przenieś wyżej',
      moveDown: 'Przenieś niżej',
      nicFirewall: 'Firewall',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Grupy firewalla',
      nicGroupsPlaceholder: 'Wybierz grupę…',
      nicGroupsHint: 'Grupy widoczne, w tym te ze scope nadrzędnych (do użycia w dół, jak tagi)',
      nicGroupCount: { one: '{n} grupa firewalla', few: '{n} grupy firewalla', many: '{n} grup firewalla', other: '{n} grupy firewalla' },
      nicOff: 'Firewall wyłączony',
      pendingRestartHint: 'Zmiany firewalla przestrzegają modelu „zapisane/zastosowane": czekają na następny power cycle (PendingRestart). Grupy wymuszone przez scope nadrzędne obowiązują, gdy firewall karty NIC jest włączony.',
      appConvergeHint: 'Zmiany firewalla obowiązują od najbliższego uzgodnienia kontenera. Grupy wymuszone przez scope nadrzędne obowiązują, gdy firewall jest włączony.',
      enforcedAncestors: 'Wymuszone przez scope nadrzędne',
      enforcedAncestorsHint: 'Ta grupa stosuje się do każdej karty NIC pod jej scope z WŁĄCZONYM firewallem — przełącznik jest głównym wyłącznikiem karty (wyłączony = żadnej chain, przodkowie włącznie); wewnątrz włączonej chain władza przodka jest ostateczna: jego drop nie otwiera się niżej.'
    }
  }
}
